export default __webpack_public_path__ + "static/media/main_area.08bd442d.png";